<template>
  <div>
    <Badges gap="1">
      <template v-if="ready">
        <template
          v-if="crmContactName"
        >
          <Badge
            status="info"
          >
            {{ crmContactName }}
          </Badge>

          <Button
            variant="badge"
            :icon-before="isUnlinking ? '' : 'fas fa-unlink'"
            :disabled="isUnlinking"
            @click="unlinkCrmContact"
          >
            {{ isUnlinking ? 'Unlinking…' : 'Unlink' }}
          </Button>
        </template>

        <Button
          v-else
          variant="badge"
          icon-before="fas fa-link"
          :disabled="!ready"
          @click="showCrmLinkingModal = true"
        >
          Link
        </Button>
      </template>

      <Button
        v-else
        variant="badge"
        :loader="true"
      >
        Syncing with CRM…
      </Button>
    </Badges>

    <StakeModal v-model="showCrmLinkingModal">
      <CrmLinkingModal
        v-if="showCrmLinkingModal"
        :entity-id="entityExternalId"
        message="Please select a CRM contact to link to this entity."
        @contact-linked="handleCrmContactLinked"
        @close="showCrmLinkingModal = false"
      />
    </StakeModal>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { ToastProgrammatic as Toast } from 'buefy';

import { useAdvisorStore } from '@frontend/ui/stores/advisorStore';
import { useEntityStore } from '@frontend/ui/stores/entityStore';

import { Badge, Badges, Button, StakeModal } from '@stakeui';
import CrmLinkingModal from '../../example/components/CrmLinkingModal.vue';

const advisorStore = useAdvisorStore();
const entityStore = useEntityStore();

const isUnlinking = ref(false);
const showCrmLinkingModal = ref(false);

const handleCrmContactLinked = async () => {
  await entityStore.fetchEntity();
  await entityStore.fetchCrmContact();

  Toast.open({
    message: 'CRM contact successfully linked.',
    type: 'is-success',
    duration: 3000,
  });
};

const unlinkCrmContact = async () => {
  isUnlinking.value = true;

  try {
    const response = await fetch(`/api/v1/entities/${entityExternalId.value}/crm-contact/`, {
      method: 'DELETE',
      headers: advisorStore.headers,
    });

    if (response.ok) {
      await entityStore.clearCrmContact();

      Toast.open({
        message: 'CRM contact successfully unlinked.',
        type: 'is-success',
        duration: 3000,
      });
    } else {
      console.error('Failed to unlink CRM contact:', response.statusText);
      alert('Failed to unlink CRM contact. Please try again.');
    }
  } catch (error) {
    console.error('Error unlinking CRM contact:', error);
    alert('An error occurred while unlinking the CRM contact. Please try again.');
  } finally {
    isUnlinking.value = false;
  }
};

const entityExternalId = computed(() => entityStore.entity?.external_id);
const crmContactName = computed(() => entityStore.crmContact?.name);
const ready = computed(() => {
  return !entityStore.isFetching &&
  !entityStore.isFetchingCrmContact;
});
</script>
